// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    getClaimTypes,
    getSubClaimTypes
} from '../../../shared/repositories';
import actions from '../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';
import {getClaimRoutes} from '../../../shared/components/create-claim-modal/get-claim-routes-service';
import {getCombinedClaimTypes} from '../../../shared/services/build-claim-types';
import {routerActions} from 'react-router-redux';

export const updateCreateClaimModalVisibility = (isOpen, pin = '') =>

    dispatch => {

        addRemoveModalClass(isOpen);

        dispatch({
            isOpen,
            pin,
            type: actions.UPDATE_PRODUCTS_BY_CUSTOMER_CREATE_CLAIM_MODAL
        });

    };

export const getClaimTypesList = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const claimTypes = await getClaimTypes();

            const subClaimTypes = await getSubClaimTypes();

            dispatch({
                claimTypes: getCombinedClaimTypes(claimTypes, subClaimTypes),
                type: actions.UPDATE_PRODUCTS_BY_CUSTOMER_CLAIM_TYPES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const onCreateClaim = (claimKey, pin) =>
    routerActions.push(getClaimRoutes(claimKey, pin));



// WEBPACK FOOTER //
// ./src/product/products-by-customer/action-creators/create-claim-modal.js